import styled from 'styled-components'

import { Button as ButtonBase } from '@application/Interfaces/Molecules/Button'
import { Link as LinkBase } from '@src/Application/Interfaces/Atoms/Link'

export const SocialBannerWrapper = styled.div`
    margin-top: 50px;
    display: none;

    @media ${(props) => props.theme.query.min.tablet} {
        display: block;
    }
`

export const SocialBannerTitle = styled.div`
    ${(props) => props.theme.typo.displayM}
    color: ${(props) => props.theme.color.g600};
`

export const SocialBannerDescription = styled.div`
    ${(props) => props.theme.typo.bodyM}
    color: ${(props) => props.theme.color.g500};
`

export const SocialLinkWrapper = styled.div`
    padding: 20px 0px 20px;

    a {
        display: inline-block;
        margin-right: 40px;
    }
`

export const Button = styled(ButtonBase)`
    margin-top: 30px;
    width: 100%;

    button {
        width: 100%;

        & > span:first-child {
            ${(props) => props.theme.typo.bodyM};
            ${(props) => props.theme.fontWeight.medium};
            text-decoration: none;
        }
    }

    @media ${(props) => props.theme.query.min.tablet} {
        margin-top: 0px;
    }
`

export const Link = styled(LinkBase)`
    display: flex;
    align-items: center;
    color: ${(props) => props.theme.color.g600};
    text-decoration: none;

    &:hover {
        color: ${(props) => props.theme.color.g500};

        svg {
            path {
                stroke: ${(props) => props.theme.color.g500};
            }
        }
    }
`
